<template>
    <div>
        <backend-errors :data="upload_avatar.error"/>

        <div align="center">
            <avatar class="is-128x128"/><br/>

            <label>
                <base-button
                    :loading="upload_avatar.loading"
                    class="is-primary"
                    icon="fas fa-upload"
                    text="Upload new avatar"/>

                <input type="file" class="is-hidden" @change="send"/>
            </label>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Avatar from '../common/Avatar.vue';
import BackendErrors from '../base/BackendErrors.vue';

export default {
    name: 'UserChangeAvatar',
    components: { BackendErrors, Avatar },
    computed: mapState('user', ['upload_avatar']),
    methods: {
        send(event) {
            this.$store.dispatch('user/upload_avatar', event.target.files[0]);
        },
    },
};
</script>
